"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkListQuerySchema = exports.WorkTaskListResponseSchema = exports.WorkTaskItemSchema = exports.WorkRequestListResponseSchema = exports.WorkRequestItemSchema = exports.ChecklistItemCreateSchema = exports.TaskUpdateSchema = exports.TaskCreateSchema = exports.TaskListResponseSchema = exports.TaskListQuerySchema = exports.TaskDetailSchema = exports.TaskChecklistItemSchema = exports.TaskSummarySchema = void 0;
const zod_1 = require("zod");
const query_1 = require("./query");
exports.TaskSummarySchema = zod_1.z.object({
    taskId: zod_1.z.number(),
    taskName: zod_1.z.string().nullable(),
    startTime: zod_1.z.string().nullable(),
    endTime: zod_1.z.string().nullable(),
    completedPercent: zod_1.z.number().nullable(),
    isCompleted: zod_1.z.boolean(),
    status: zod_1.z.number().nullable(),
    commanderId: zod_1.z.number().nullable(),
    enforcementId: zod_1.z.number().nullable(),
    orgId: zod_1.z.number().nullable(),
    parentId: zod_1.z.number().nullable(),
});
exports.TaskChecklistItemSchema = zod_1.z.object({
    itemId: zod_1.z.number(),
    name: zod_1.z.string().nullable(),
    weight: zod_1.z.number().nullable(),
    target: zod_1.z.string().nullable(),
    type: zod_1.z.number().nullable(),
    parentId: zod_1.z.number().nullable(),
    order: zod_1.z.number().nullable(),
});
exports.TaskDetailSchema = exports.TaskSummarySchema.extend({
    content: zod_1.z.string().nullable(),
    target: zod_1.z.string().nullable(),
    taskResult: zod_1.z.string().nullable(),
    weight: zod_1.z.number().nullable(),
    taskType: zod_1.z.number().nullable(),
});
exports.TaskListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(50),
    q: zod_1.z.string().trim().optional(),
    status: zod_1.z.coerce.number().int().optional(),
    commanderId: zod_1.z.coerce.number().int().optional(),
    enforcementId: zod_1.z.coerce.number().int().optional(),
    completed: query_1.QueryBoolean.optional(),
    fromDate: zod_1.z.string().optional(),
    toDate: zod_1.z.string().optional(),
});
exports.TaskListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.TaskSummarySchema),
    total: zod_1.z.number(),
    page: zod_1.z.number(),
    pageSize: zod_1.z.number(),
});
exports.TaskCreateSchema = zod_1.z.object({
    taskName: zod_1.z.string().min(1).max(2000),
    content: zod_1.z.string().optional(),
    target: zod_1.z.string().optional(),
    startTime: zod_1.z.string().optional(),
    endTime: zod_1.z.string().optional(),
    commanderId: zod_1.z.number().int().optional(),
    enforcementId: zod_1.z.number().int().optional(),
    orgId: zod_1.z.number().int().optional(),
    parentId: zod_1.z.number().int().optional(),
    weight: zod_1.z.number().int().optional(),
    taskType: zod_1.z.number().int().optional(),
});
exports.TaskUpdateSchema = exports.TaskCreateSchema.partial().extend({
    completedPercent: zod_1.z.number().optional(),
    isCompleted: zod_1.z.boolean().optional(),
    status: zod_1.z.number().int().optional(),
    taskResult: zod_1.z.string().optional(),
});
exports.ChecklistItemCreateSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(2000),
    weight: zod_1.z.number().int().optional(),
    target: zod_1.z.string().optional(),
    type: zod_1.z.number().int().optional(),
    order: zod_1.z.number().int().optional(),
});
/* === Quản lý công việc (OLD tree_task / tree_task_unit / requisition_task views) === */
/** /task/requests — Theo dõi yêu cầu công việc (text_process ⟗ text). */
exports.WorkRequestItemSchema = zod_1.z.object({
    textId: zod_1.z.number(),
    title: zod_1.z.string().nullable(),
    code: zod_1.z.string().nullable(),
    registerNumber: zod_1.z.string().nullable(),
    state: zod_1.z.number().nullable(),
    createDate: zod_1.z.string().nullable(),
    creatorName: zod_1.z.string().nullable(),
    myState: zod_1.z.number().nullable(),
    sendDate: zod_1.z.string().nullable(),
    signLevel: zod_1.z.number().nullable(),
});
exports.WorkRequestListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.WorkRequestItemSchema),
    total: zod_1.z.number(),
    page: zod_1.z.number(),
    pageSize: zod_1.z.number(),
});
/** /task/summary — Tổng hợp công việc (task where I'm creator or assignee). */
/** /task/dept — Công việc phòng ban (task_assign OBJECT_TYPE=2 in my org tree). */
exports.WorkTaskItemSchema = zod_1.z.object({
    taskId: zod_1.z.number(),
    taskName: zod_1.z.string().nullable(),
    startTime: zod_1.z.string().nullable(),
    endTime: zod_1.z.string().nullable(),
    createdDate: zod_1.z.string().nullable(),
    status: zod_1.z.number().nullable(),
    creatorId: zod_1.z.number().nullable(),
    creatorName: zod_1.z.string().nullable(),
    assigneeLabel: zod_1.z.string().nullable(),
});
exports.WorkTaskListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.WorkTaskItemSchema),
    total: zod_1.z.number(),
    page: zod_1.z.number(),
    pageSize: zod_1.z.number(),
});
exports.WorkListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(25),
    q: zod_1.z.string().trim().optional(),
    fromDate: zod_1.z.string().optional(),
    toDate: zod_1.z.string().optional(),
});
